import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSliders = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1765 2L17.8235 2L17.8235 4.16216L21 4.16216L21 6.86486L17.8235 6.86486L17.8235 9.02703L15.1765 9.02703L15.1765 2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0588 4.16216L13.0588 6.86486L3 6.86486L3 4.16216L13.0588 4.16216Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 10.6486L21 13.3514L10.9412 13.3514L10.9412 10.6486L21 10.6486Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 17.1351L10.9412 17.1351L10.9412 19.8378L3 19.8378L3 17.1351Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.82353 8.48649L8.82353 15.5135L6.17647 15.5135L6.17647 13.3514L3 13.3513L3 10.6486L6.17647 10.6486L6.17647 8.48649L8.82353 8.48649Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.0588 14.973L15.7059 14.973L15.7059 17.1351L21 17.1351L21 19.8378L15.7059 19.8378L15.7059 22L13.0588 22L13.0588 14.973Z",
			fill: "currentColor"
		})
	]
});
export default SvgSliders;
